import React from 'react';

import scss from './HighlightedText.module.scss';

const HighlightedText = ({ value = '', searchTerm = '', className = '' }) => {
  if (!searchTerm || !value) {
    return <span className={className}>{value}</span>;
  }
  const index = value.toLowerCase().indexOf(searchTerm.toLowerCase());

  if (index === -1) {
    return <span className={className}>{value}</span>;
  }

  const prefix = value.substring(0, index);
  const highlightedPart = value.substring(index, index + searchTerm.length);
  const postfix = value.substring(index + searchTerm.length, value.length);

  return (
    <span className={className}>
      {prefix}
      <span className={scss.highlighted}>{highlightedPart}</span>
      {postfix}
    </span>
  );
};

export default HighlightedText;
